export const DAYS_PER_WEEK = 7;
export const MINUTES_PER_DAY = 1440; // 60 * 24
export const SECONDS_PER_HOUR = 3600; // 60 * 60
export const SECONDS_PER_DAY = 86400; // 60 * 60 * 24
export const SECONDS_PER_WEEK = 604800; // 60 * 60 * 24 * 7
export const MS_PER_HOUR = 3600000; // 60 * 60 * 1000
export const MS_PER_DAY = 86400000; // 60 * 60 * 24 * 1000

/**
 * Given two timestamps in ms, returns the estimated difference in days
 * Rounding option can be specified.
 */
export const getDaysElapsed = (
  startTimestampMs: number,
  endTimestampMs: number,
  roundMethod: "round" | "floor" | "ceil" = "floor",
) => {
  switch (roundMethod) {
    case "round":
      return Math.round((endTimestampMs - startTimestampMs) / MS_PER_DAY);
    case "ceil":
      return Math.ceil((endTimestampMs - startTimestampMs) / MS_PER_DAY);
    default:
      return Math.floor((endTimestampMs - startTimestampMs) / MS_PER_DAY);
  }
};
